export default __webpack_public_path__ + "static/media/ic_glp_40.2c6aa73f.svg";